import React from 'react';
import { css } from '@emotion/react';
import Colors from '../../../../types/colors';
import ButtonView from '../../../atoms/inputs/button.view';
import { IChartLegendItem } from './const';
interface BarChartLegendProps {
  buildDomToImage?: () => void;
  currentLegendList: IChartLegendItem[];
}

const BarChartLegend = ({ buildDomToImage, currentLegendList }: BarChartLegendProps) => {
  const getLegend = (color: string) => css`
    width: 10px;
    height: 10px;
    background-color: ${color};
    border-radius: 99px;
  `;

  const tabWrapper = css`
    display: flex;
    flex-direction: row;
    padding: 0 0.3rem;
    justify-content: space-between;
    font-size: 11px;
    color: ${Colors['Grey_03_regular']};
    width: 100%;
    overflow: hidden;
  `;
  const colorWrapper = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
    font-size: 10px;
    white-space: nowrap;
  `;

  const LegendContainer = css`
    display: flex;
    flex-direction: column;
    gap: 4px;
  `;
  const LegendRowContainer = css`
    display: flex;
    gap: 16px;
    align-items: center;
  `;

  const getLegendItem = ({ label, color }: IChartLegendItem) => (
    <div css={colorWrapper} key={label}>
      <div css={getLegend(color)} />
      <span>{label}</span>
    </div>
  );

  const getLegendLineItems = (target: number) => currentLegendList.filter(({ line = 0 }) => line === target).map((item) => getLegendItem(item));

  return (
    <div css={tabWrapper}>
      <div css={LegendContainer}>
        <div css={LegendRowContainer}>{getLegendLineItems(0)}</div>
        <div css={LegendRowContainer}>{getLegendLineItems(1)}</div>
      </div>
      <div className="save_image_btn" css={colorWrapper}>
        {buildDomToImage && <ButtonView handleClick={buildDomToImage} text="결과 다운로드" variant="secondary" size={26} />}
      </div>
    </div>
  );
};

export default BarChartLegend;
